import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarDays, Mic, Phone, HeartHandshake } from 'lucide-react';
import { useT } from './i18n';

const NAV = [
  { to: '/app', end: true, icon: Home, key: 'nav.home' },
  { to: '/app/programs', icon: CalendarDays, key: 'nav.programs' },
  { to: '/app/prayer', icon: HeartHandshake, key: 'nav.prayer', label: 'Prayer' },
  { to: '/app/message', icon: Mic, key: 'nav.message' },
  { to: '/app/contact', icon: Phone, key: 'nav.contact' },
];

const BottomNav = () => {
  const t = useT();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.05)] pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-5 max-w-md mx-auto">
        {NAV.map(({ to, end, icon: Icon, key, label }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              data-testid={`mobile-nav-${key.split('.')[1]}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-medium transition-colors ${
                  isActive
                    ? 'text-emerald-700'
                    : 'text-gray-500 hover:text-emerald-700'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`}
                  />
                  <span>{label || t(key)}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomNav;
